export interface CarouselState {
  createdAt: any;
  title: string;
  place: string;
  customPLP: {
    filters: {
      promoTag: string;
      isHasPromotion: boolean;
      categoryIds: any[];
    };
    slug: string;
    sortedIds:any[];
  };
  showAllEnabled: boolean;
  limit: number;
}

export const CarouselInitialState: CarouselState = {
  createdAt: '',
  title: '',
  place: '',
  customPLP: {
    filters: {
      promoTag: '',
      isHasPromotion: false,
      categoryIds: [],
    },
    slug: '',
    sortedIds:[]
  },
  showAllEnabled: false,
  limit: 200
};
